import GameOptions from "../../../model/options/GameOptions.js";
import Page from "../../framework/Page.js";
import ParentView from "../../framework/ParentView.js";
import { PageIds } from "../../PageIds.js";
import CrewBrainGameOptionsToggle from "./CrewBrainGameOptionsToggle.js";
import DepthColumnGameOptionsToggle from "./DepthColumnGameOptionsToggle.js";
import DisplayFpsGameOptionsToggle from "./DisplayFpsGameOptionsToggle.js";
import EffectRenderingGameOptionsToggle from "./EffectRenderingGameOptionsToggle.js";
import FpsThrottleSettingView from "./FpsThrottleSettingView.js";
import WireFrameGameOptionsToggle from "./WireFrameGameOptionsToggle.js";

export default class GameOptionsPopupView extends ParentView  {
    /**
     * @param {string} parentId 
     * @param {GameOptions} gameOptions
     */
    constructor(parentId, gameOptions) {
        super(parentId, PageIds.GAME_OPTIONS_POPUP);

        /**
         * @constant
         * @type {GameOptions}
         */
        this.gameOptions = gameOptions;

        /**
         * @type {HTMLElement}
         */
        this.container = null;

        /**
         * @constant
         * @type {string}
         */
        this.containerId = 'gameOptionsContainer';

        this.addView(new CrewBrainGameOptionsToggle(this.containerId, this.containerId + '_brain', 'Crew Brain Debug', gameOptions));
        this.addView(new DisplayFpsGameOptionsToggle(this.containerId, this.containerId + '_fps', 'Display FPS', gameOptions));
        this.addView(new EffectRenderingGameOptionsToggle(this.containerId, this.containerId + '_fx', 'Effect/Skill Rendering', gameOptions));
        this.addView(new DepthColumnGameOptionsToggle(this.containerId, this.containerId + '_depth', 'Depth Column Rendered', gameOptions));
        this.addView(new WireFrameGameOptionsToggle(this.containerId, this.containerId + '_wire', 'Wireframe Tiles', gameOptions));
        this.addView(new FpsThrottleSettingView(this.containerId, this.containerId + '_throttle', gameOptions));
    }

    /**
     * Invoked at startup or after a save has been loaded.
     * @override
     */
    initializeView() {
        const parentElement = Page.getElement(this.parentId);
        const popupElement = Page.createElement('div', parentElement, this.getElementId(), 'popup-window-prestige');

        const container = Page.createElement('div', popupElement, null, null);

        ////////////////////////////////////////
        // Header
        ////////////////////////////////////////

        const header = Page.createElement('div', container, null, 'popup-window-header');
        header.innerHTML = 'Settings';

        const thisRef = this;

        header.onclick = function () {
            thisRef.setViewVisible(false);
            return false;
        };

        ////////////////////////////////////////
        // Container
        ////////////////////////////////////////

        const sectionBody = Page.createElement('div', container, null, 'menu-section-body');

        this.container = Page.createElement('div', sectionBody, this.containerId, null);
        

        this.setInitialVisibility(false);

        super.initializeView();
    }

    // /**
    //  * @override
    //  */
    // updateViewContents() {
    //     super.updateViewContents();
    // }
}